import React from 'react';
import { formatDate, DATE_FORMAT } from '@shootsta/get-moment';
import '../styles/_asset-details-list.scss';
import { Button, FormModal, Input, Text } from '../../../../../../../../ui-kit';
import AssetPreview from '../../../../../../../AssetPreview/containers/AssetPreview';
import { bytesToSize } from '../../../utils';
import { DownloadAssetMenu } from '../../../../../../../DownloadAssetMenu';








function AssetDetailsModal(props) {
  const {
    showAssetDetailsModal,
    closeModal,
    assetDetail,
    handleChangeCustomAssetDescription
  } = props;

  const assetDetails = React.useMemo(() => {
    if (!assetDetail) return {};

    const {
      filename,
      assetId,
      updatedAt,
      metaData
    } = assetDetail.assetDetail;

    const metadata = JSON.parse(metaData);
    const { size, type } = metadata;
    return { size, type, filename, assetId, updatedAt };
  }, [assetDetail]);

  const { size, type, filename, assetId, updatedAt } = assetDetails;

  const renderDownloadButton = () =>
  <div className="asset-details--download-btn">
      <DownloadAssetMenu id={assetId} asset={assetDetail.assetDetail}>
        <Button
        hasMenuIcon
        type="PRIMARY">

          Download
        </Button>
      </DownloadAssetMenu>
    </div>;


  const handleDescription = (value) => {
    if (!handleChangeCustomAssetDescription) return;
    handleChangeCustomAssetDescription(assetId, value);
  };

  return (
    <div className="asset-details">
      <FormModal
        visible={showAssetDetailsModal}
        title="Asset Details"
        onSave={() => closeModal()}
        onClose={() => closeModal()}
        showCancelBtn={false}
        saveBtnType="SECONDARY"
        mediumWidth={95}
        hideFooter>

        <div className="asset-details page__content">
          <div className="asset-details__preview">
            <div className="asset-details__preview--image">
              <AssetPreview
                canPlayVideo
                canPlayAudio
                assetId={assetId}
                hideFileTypeIcon
                darkMode
                width={450}
                height={250} />

            </div>
            <div className="asset-details__preview">
              <div className="asset-details__preview--filename">
                <Text heading5 noMargin>{filename}</Text>
              </div>
              <div className="asset-details__preview--meta">
                <Text label noMargin>
                  {`${formatDate(updatedAt, DATE_FORMAT.MONTH_SHORT_DAY_YEAR)}`}
                </Text>
                <Text noMargin label>{`${type.replace('/', ' / ')} | ${bytesToSize(Number(size))}`}</Text>
              </div>
            </div>
          </div>
          <div className="asset-details__input-continer">
            <Text heading5>Details</Text>
            <Input
              label="Additional Info"
              onChange={(e) => handleDescription(e)}
              defaultValue={assetDetail.additionalInfo}
              value={assetDetail.additionalInfo} />

          </div>
        </div>
        {renderDownloadButton()}
      </FormModal>
    </div>);

}

export default AssetDetailsModal;